import { Button, Card, Checkbox, Divider, Flex, Form, Input, Modal, Space } from 'antd';
import { EyeTwoTone, EyeInvisibleOutlined } from '@ant-design/icons';
import ImagePicker from 'components/pickers/image/Image';
import ProductSample from 'components/pickers/sample_products';

function CreateShopDesktop({ viewModel }) {
  const {
    token,
    form,
    otpForm,
    navigate,
    isShowOtp,
    setIshowOpt,
    handleCreate,
    onFinish,
    onOtpFinish,
    phoneValidator,
  } = viewModel;

  return (
    <Card style={{ width: '500px', position: 'absolute', top: '0%', left: '50%', transform: 'translate(-50%, -0%)' }}>
      <Flex vertical gap={14}>
        <Space direction="vertical" style={{ textAlign: 'center' }}>
          <img alt="sipro-logo" width={200} style={{ borderRadius: '8px' }} src="https://storage.googleapis.com/cubebio/default/siprologo.png" />
          <span style={{ fontSize: token.fontSizeHeading3, fontWeight: '500' }}>Sỉ Pro - Bán sỉ chuyên nghiệp</span>
          <span>Đăng ký ngay để sở hữu website bán sỉ chuyên nghiệp, tự động hóa mọi thao tác thủ công.</span>
        </Space>

        <Form layout="vertical" form={form} initialValues={{}} onFinish={onFinish}>
          <Divider>Tài khoản</Divider>

          <Form.Item
            label="Số điện thoại"
            name="phone"
            rules={[
              { required: true, pattern: /^[0-9]{10}$/, message: 'Số điện thoại không đúng định dạng' },
              { validator: phoneValidator },
            ]}
          >
            <Input placeholder="Dùng đăng nhập trang admin"></Input>
          </Form.Item>

          <Form.Item label="Mật khẩu" name="pass" rules={[{ required: true }]}>
            <Input.Password placeholder="Password" iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
          </Form.Item>

          <Divider>Cửa hàng</Divider>

          <Form.Item label="Tên cửa hàng" name={['shop', 'title']} rules={[{ required: true, min: 5, message: 'Tên shop tối thiểu 5 ký tự' }]}>
            <Input placeholder="ví dụ: Ăn vặt Thuỷ Tiên"></Input>
          </Form.Item>

          <Form.Item label="Logo" name={['shop', 'image']} rules={[]}>
            <ImagePicker></ImagePicker>
          </Form.Item>

          <Form.Item label="Mô tả" name={['shop', 'description']} rules={[]}>
            <Input />
          </Form.Item>

          <Form.Item label="Sản phẩm mẫu" name={['shop', 'products']} rules={[]}>
            <ProductSample />
          </Form.Item>

          <Form.Item
            name="agree"
            valuePropName="checked"
            rules={[{ validator: (_, value) => (value ? Promise.resolve() : Promise.reject(new Error('Bạn phải đồng ý với chính sách dịch vụ'))) }]}
          >
            <Checkbox>
              {' '}Tôi đồng ý <a href="#" target="_blank"> Terms of Service</a> , <a href="#" target="_blank"> Privacy Policy</a> .
            </Checkbox>
          </Form.Item>

          <Space direction="vertical" style={{ width: '100%' }} size={'large'}>
            <Button type="primary" style={{ width: '100%' }} onClick={handleCreate}>
              Tạo tài khoản
            </Button>
            <Flex align="center" justify="center">
              <span>Already have an account?</span>
              <Button type="link" onClick={() => navigate('/login')}>
                Login
              </Button>
            </Flex>
          </Space>
        </Form>
      </Flex>

      <Modal
        title="Xác nhận otp"
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isShowOtp}
        onOk={() => otpForm.submit()}
        onCancel={() => setIshowOpt(false)}
        onClose={() => setIshowOpt(false)}
        okText="Xác nhận"
      >
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
          <Form layout="vertical" form={otpForm} initialValues={{}} onFinish={onOtpFinish} style={{ width: 300 }}>
            <Form.Item
              label="OTP"
              name="otp"
              rules={[
                { required: true },
                { pattern: /^[0-9]{4}$/, message: 'OTP must be a 4-digit number' },
              ]}
            >
              <Input.OTP length={4} style={{ width: '100%' }} />
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </Card>
  );
}

export default CreateShopDesktop;
